export default {
  analytics: '/api/analytics'
};
